export default {"src":"/_next/static/media/coaches.66746a9b.svg","height":28,"width":29,"blurWidth":0,"blurHeight":0};